const Footer = () => {
    return (
        <div className="app-wrapper-footer">
            <div className="app-footer">
                <div className="app-footer__inner">
                    <div className="app-footer-left">
                        <span>Copyright © <span id="printYear"> 2026 </span> Rajwada Group. All rights reserved.</span>
                    </div>
                    <div className="app-footer-right">
                        <span>Developed by <a href="https://www.zorya.co.in/" target="_blank" rel="noopener noreferrer"> Zorya.</a></span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer